import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Publication } from '../../interfaces/publication';
import { Subscription } from 'rxjs';
import { BbTableService, TableRow } from '../../services/bb-table.service';
import { UploadService } from '../../services/upload.service';
import { Embargo } from '../shared/bb-embargo/bb-embargo.component';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
	selector: 'dashboard-media',
	templateUrl: './dashboard-media.component.html',
	styleUrls: ['./dashboard-media.component.scss']
})

export class DashboardMediaComponent implements OnInit {
	autoName = false;
	autoPublish = false;
	embargo: Embargo;
	rows: TableRow[] = null;

	// TODO: implement rowsContainLiveClips
	rowsContainLiveClips: boolean;

	subscriptions: Subscription = new Subscription();
	publicationLabel: Publication;
	protected rowDoubleClickedSubscription: Subscription;

	constructor(
		protected route: ActivatedRoute,
		private router: Router,
		protected bbTableService: BbTableService,
		protected uploadService: UploadService,
		protected localStorageService: LocalStorageService) {
	}

	ngOnInit() {
		this.bbTableService
			.useOverlayLoading(false)
			.sort('createddate', 'desc')
			.setLimit(5)
			.setEntity('mediaclip')
			.setLiveUpdates(true);

		this.subscriptions.add(this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => this.rows = rows));
		this.uploadService.completedObservable.subscribe(() => this.bbTableService.getRows(true));
		this.rowDoubleClickedSubscription = this.bbTableService.rowDoubleClickedObservable.subscribe((row: TableRow) => {
			this.redirectToDetails(row);
		});

		this.bbTableService.getRows();
		this.getSettings();
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['library/mediaclip', row.data.id, 'metadata']);
		}
	}

	getSettings() {
		if (typeof this.localStorageService.get('ovp-autoName') !== 'undefined') {
			this.autoName = this.localStorageService.get('ovp-autoName');
		}
		if (typeof this.localStorageService.get('ovp-autoPublish') !== 'undefined') {
			this.autoPublish = this.localStorageService.get('ovp-autoPublish');
		}
	}
}
